
export const pcMain = [
  {
    name: 'pc',
    path: '/pc',
    meta: {
      title: 'PC页面装修',
      icon: 'shezhi',
      plugin: 'pc'
    }
  },
  {
    name: 'pcThemes',
    path: '/pc/themes',
    plugin: 'pc',
    component: () => import('/@/views/plugins/pc/Themes.vue'),
    meta: { title: 'PC主题选择', plugin: 'pc' }
  },
  {
    name: 'pcPage',
    path: '/pc/page',
    plugin: 'pc',
    component: () => import('/@/views/plugins/pc/Page.vue'),
    meta: { title: 'PC装修列表', plugin: 'pc' }
  },
  {
    name: 'pcHeader',
    path: '/pc/header',
    plugin: 'pc',
    component: () => import('/@/views/plugins/pc/Header.vue'),
    meta: { title: 'PC顶部导航', plugin: 'pc' }
  }
]
export const pcOpen = [
  {
    name: 'pcHandle',
    path: '/pc/handle',
    plugin: 'pc',
    component: () => import('/@/views/plugins/pc/Handle.vue'),
    meta: { title: 'PC页面装修', plugin: 'pc' }
  }
]
